import React, { createContext, useContext } from "react";
import { SocketUrls } from "../../constants/baseurl";
import { useSignalRConnection } from "../../suckets/ReusableHookWrapper";

interface SignalRProviderProps {
  token: string;
  children: React.ReactNode;
}

const SignalRContext = createContext<any>(null);

export const SignalRProvider = ({ token, children }: SignalRProviderProps) => {
  // Accounting Hub
  const accountingConnection = useSignalRConnection({
    url: SocketUrls.accountingInstances,
    token,
    onConnect: () => console.log("✅ Connected to Accounting Hub"),
    onDisconnect: () => console.log("🔌 Disconnected from Accounting Hub"),
  });

  // Hospitality Hub with roomcategorycreated handler
  const hospitalityConnection = useSignalRConnection({
    url: SocketUrls.hospitalityInstances,
    token,
    onConnect: () => console.log("✅ Connected to Hospitality Hub"),
    onDisconnect: () => console.log("🔌 Disconnected from Hospitality Hub"),
    hubHandlers: {
      roomcategorycreated: (payload) => {
        console.log("📦 Room category created:", payload);
        // You can trigger a state update, dispatch to Redux, or show a toast here
      },
    },
  });

  // CRM Hub
  const crmConnection = useSignalRConnection({
    url: SocketUrls.crmInstances,
    token,
    onConnect: () => console.log("✅ Connected to CRM Hub"),
    onDisconnect: () => console.log("🔌 Disconnected from CRM Hub"),
  });

  // Deliverable Hub
  const deliverableConnection = useSignalRConnection({
    url: SocketUrls.deliverableInstances,
    token,
    onConnect: () => console.log("✅ Connected to Deliverable Hub"),
    onDisconnect: () => console.log("🔌 Disconnected from Deliverable Hub"),
  });

  return (
    <SignalRContext.Provider
      value={{
        accountingConnection,
        hospitalityConnection,
        crmConnection,
        deliverableConnection,
      }}
    >
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => useContext(SignalRContext);